import {ReactNode, useEffect, useState} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {Splash} from '@/components/Splash';
import {useSession} from '@/hooks/session';
import {paths} from './path';

interface IProps {
  delay?: number;
  children: ReactNode[] | ReactNode;
}

export const ProtectedRoute = ({delay, children}: IProps) => {
  const {hasSession, isPending} = useSession();
  const {pathname, search} = useLocation();
  const [ready, setReady] = useState<boolean>(!delay || delay > 0);

  useEffect(() => {
    if (delay) {
      const timer = setTimeout(() => {
        setReady(true);
      }, delay);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [delay]);

  if (!ready || isPending) {
    return <Splash />;
  } else if (!hasSession) {
    return (
      <Navigate
        to={{pathname: paths.signin}}
        state={{from: {pathname, search}}}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
